import Navbar from "@/components/feature/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Solutions from "./components/Solutions";
import FeaturedProducts from "./components/FeaturedProducts";
import Industries from "./components/Industries";
import WhyUs from "./components/WhyUs";
import LatestProjects from "./components/LatestProjects";
import Process from "./components/Process";
import Guarantee from "./components/Guarantee";
import Testimonials from "./components/Testimonials";
import LatestBlog from "./components/LatestBlog";
import FAQ from "./components/FAQ";
import CTA from "./components/CTA";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Solutions />
      <About />
      <FeaturedProducts />
      <Industries />
      <WhyUs />
      <LatestProjects />
      <Process />
      <Guarantee />
      <Testimonials />
      <LatestBlog />
      <FAQ />
      <CTA />
      <Footer />
    </main>
  );
}